"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _SharedUser = _interopRequireDefault(require("../SharedUser"));
var _SharedTeam = _interopRequireDefault(require("../SharedTeam"));
var _SharedOrganization = _interopRequireDefault(require("../SharedOrganization"));
var SharedIdentity = function SharedIdentity(_ref) {
  var identity = _ref.identity,
    isCurrentUser = _ref.isCurrentUser;
  switch (identity.identityType) {
    case 'team':
      return /*#__PURE__*/_react.default.createElement(_SharedTeam.default, {
        team: identity
      });
    case 'user':
      return /*#__PURE__*/_react.default.createElement(_SharedUser.default, {
        user: identity,
        isCurrentUser: isCurrentUser
      });
    case 'externalOrganization':
      return /*#__PURE__*/_react.default.createElement(_SharedOrganization.default, {
        organization: identity,
        isCurrentUser: isCurrentUser,
        isExternal: true
      });
    case 'organization':
      return /*#__PURE__*/_react.default.createElement(_SharedOrganization.default, {
        organization: identity,
        isCurrentUser: isCurrentUser
      });
    default:
      return 'Unspecified identity';
  }
};
SharedIdentity.propTypes = {
  identity: _propTypes.default.object,
  isCurrentUser: _propTypes.default.bool
};
var _default = exports.default = SharedIdentity;
//# sourceMappingURL=SharedIdentity.js.map